module.exports = __webpack_public_path__ + "static/media/claims_rejected_label.56536f8b.png";